"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyDevice = exports.verifyAddress = exports.processingConfirmWithdraw = exports.finishedVerifyDevice = exports.finishedVerifyAddress = exports.finishedConfirmWithdraw = exports.fetchConfirmWithdraw = exports.PROCESSING_VERIFY_DEVICE = exports.PROCESSING_VERIFY_ADDRESS = exports.PROCESSING_CONFIRM_WITHDRAW = exports.FINISHED_VERIFY_DEVICE = exports.FINISHED_VERIFY_ADDRESS = exports.FINISHED_CONFIRM_WITHDRAW = void 0;
var PROCESSING_CONFIRM_WITHDRAW = exports.PROCESSING_CONFIRM_WITHDRAW = 'PROCESSING_CONFIRM_WITHDRAW';
var FINISHED_CONFIRM_WITHDRAW = exports.FINISHED_CONFIRM_WITHDRAW = 'FINISHED_CONFIRM_WITHDRAW';
var PROCESSING_VERIFY_ADDRESS = exports.PROCESSING_VERIFY_ADDRESS = 'PROCESSING_VERIFY_ADDRESS';
var FINISHED_VERIFY_ADDRESS = exports.FINISHED_VERIFY_ADDRESS = 'FINISHED_VERIFY_ADDRESS';
var PROCESSING_VERIFY_DEVICE = exports.PROCESSING_VERIFY_DEVICE = 'PROCESSING_VERIFY_DEVICE';
var FINISHED_VERIFY_DEVICE = exports.FINISHED_VERIFY_DEVICE = 'FINISHED_VERIFY_DEVICE';
var verifyDevice = exports.verifyDevice = function verifyDevice(payload) {
  return function (dispatch) {
    var verifycode = payload.verifycode,
      UserId = payload.UserId,
      d1 = payload.d1,
      hashCode = payload.hashCode;
    dispatch({
      type: PROCESSING_VERIFY_DEVICE
    });
    var fetchUrl = atob(d1);
    var fetchPayload = {
      OMSId: 1,
      PendingEmailCode: verifycode,
      UserId: Number(UserId),
      HashCode: hashCode
    };
    fetch(fetchUrl + 'RegisterNewDevice', {
      method: 'POST',
      body: JSON.stringify(fetchPayload)
    }).then(function (res) {
      return res.json();
    }).then(function (response) {
      if (response.result) {
        return dispatch(finishedVerifyDevice({
          error: false,
          message:
          // t('Your device has been successfully registered.')
          'Your device has been successfully registered.'
        }));
      }
      dispatch(finishedVerifyDevice({
        error: true,
        message:
        // t('Your device registration failed. Try clicking the link in the email you received again. Contact the exchange admin if the problem persists.')
        'Your device registration failed. Try clicking the link in the email you received again. Contact the exchange admin if the problem persists.'
      }));
    })["catch"](function () {
      return dispatch(finishedVerifyDevice({
        error: true,
        message:
        // t('Your device registration failed. Try clicking the link in the email you received again. Contact the exchange admin if the problem persists.')
        'Your device registration failed. Try clicking the link in the email you received again. Contact the exchange admin if the problem persists.'
      }));
    });
  };
};
var verifyAddress = exports.verifyAddress = function verifyAddress(payload) {
  return function (dispatch) {
    var verifycode = payload.verifycode,
      AccountId = payload.AccountId,
      d1 = payload.d1;
    dispatch({
      type: PROCESSING_VERIFY_ADDRESS
    });
    var fetchUrl = atob(d1);
    var fetchPayload = {
      OMSId: 1,
      VerifyEmailCode: verifycode,
      AccountId: Number(AccountId)
    };
    fetch(fetchUrl + 'ConfirmWithdrawInfo', {
      method: 'POST',
      body: JSON.stringify(fetchPayload)
    }).then(function (res) {
      return res.json();
    }).then(function (response) {
      if (response.result) {
        return dispatch(finishedVerifyAddress({
          error: false,
          message:
          // t('Your address has been successfully whitelisted.')
          'Your address has been successfully whitelisted.'
        }));
      }
      dispatch(finishedVerifyAddress({
        error: true,
        message:
        // t('Your whitelist confirmation failed. Try clicking the link in the email you received again. Contact the exchange admin if the problem persists.')
        'Your whitelist confirmation failed. Try clicking the link in the email you received again. Contact the exchange admin if the problem persists.'
      }));
    });
  };
};
var finishedVerifyAddress = exports.finishedVerifyAddress = function finishedVerifyAddress(payload) {
  return {
    type: FINISHED_VERIFY_ADDRESS,
    payload: payload
  };
};
var finishedVerifyDevice = exports.finishedVerifyDevice = function finishedVerifyDevice(payload) {
  return {
    type: FINISHED_VERIFY_DEVICE,
    payload: payload
  };
};
var processingConfirmWithdraw = exports.processingConfirmWithdraw = {
  type: PROCESSING_CONFIRM_WITHDRAW
};
var finishedConfirmWithdraw = exports.finishedConfirmWithdraw = function finishedConfirmWithdraw(payload) {
  return {
    type: FINISHED_CONFIRM_WITHDRAW,
    payload: payload
  };
};
var fetchConfirmWithdraw = exports.fetchConfirmWithdraw = function fetchConfirmWithdraw(payload) {
  return function (dispatch) {
    var verifycode = payload.verifycode,
      userid = payload.userid,
      d1 = payload.d1;
    dispatch(processingConfirmWithdraw);
    var fetchUrl = atob(d1);
    var fetchPayload = {
      verifycode: verifycode,
      UserId: Number(userid)
    };
    fetch(fetchUrl + 'confirmwithdraw', {
      method: 'POST',
      body: JSON.stringify(fetchPayload)
    }).then(function (response) {
      if (response.ok) {
        return dispatch(finishedConfirmWithdraw({
          error: false,
          message:
          // t('Your withdrawal has been confirmed successfully and has started processing.')
          'Your withdrawal has been confirmed successfully and has started processing.'
        }));
      }
      dispatch(finishedConfirmWithdraw({
        error: true,
        message:
        // t('Your withdrawal confirmation failed. Try clicking the link in the email you received again. Contact the exchange admin if the problem persists.')
        'Your withdrawal confirmation failed. Try clicking the link in the email you received again. Contact the exchange admin if the problem persists.'
      }));
    });
  };
};